<template>
    <div class="footer-content">
        <a-button @click="onGenerateNewFormulaBtnClick">生成新配方</a-button>
        <a-button @click="onImportFormulaModelBtnClick">导入配方模型</a-button>

        <a-modal :visible="generateNewFormulaVisible" title="生成新配方" @cancel="onGenerateNewFormulaCancel"
            @ok="generateNewFormula">
            <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                <a-form-item label="配方类型" style="margin-bottom: 0;">
                    <label> {{ formulaTypeName(formulaType) }} </label>
                </a-form-item>
                <a-form-item label="新配方名称" style="margin-bottom: 0;">
                    <a-input placeholder="请输入新配方名称" v-model="form.formulaName" />
                </a-form-item>
            </a-form>
        </a-modal>

        <a-modal :visible="importFormulaModelVisible" title="导入配方模型" @cancel="onImportFormulaModelCancel"
            @ok="importFormulaModel">
            <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                <a-form-item label="配方类型" style="margin-bottom: 0;">
                    <label> {{ formulaTypeName(formulaType) }} </label>
                </a-form-item>
                <a-form-item label="导入配方" style="margin-bottom: 0;">
                    <a-select show-search allow-clear :value="form.formulaId" placeholder="输入配方名称或配方代码"
                        style="width: 200px" :filter-option="false" @search="onFormulaSearchDebounce"
                        @change="onFormulaChange">
                        <a-spin v-if="formulaFetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="formula in formulaList" :key="formula.id">
                            {{ formula.formulaName }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
import _ from 'lodash';
import { formulaTypeName } from '@/components/Common/Utils/Utils.js';

export default {
    props: {
        productName: {
            type: String,
            default: ''
        },
        formulaType: {
            type: Number,
            default: NaN
        },
        shareId: {
            type: String,
            default: ''
        },
        productId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            generateNewFormulaVisible: false,
            form: {
                formulaName: '',
                formulaId: undefined
            },
            importFormulaModelVisible: false,
            formulaList: [],
            formulaFetching: false,
            onFormulaSearchDebounce: null
        };
    },
    mounted() {
        this.onFormulaSearchDebounce = _.debounce(this.onFormulaSearch, 500);
    },
    methods: {
        formulaTypeName(formulaType) {
            return formulaTypeName(formulaType);
        },
        onGenerateNewFormulaBtnClick() {
            this.form.formulaName = this.productName + 'copy';
            this.generateNewFormulaVisible = true;
        },
        generateNewFormula() {
            this.$http.post('/nhf-app/formulaproductext/generateNewFormula', { productKeyword: this.form.formulaName, productShareId: this.shareId }).then(res => {
                if (res.success) {
                    this.$message.success('生成成功');
                    this.generateNewFormulaVisible = false;
                } else {
                    this.$message.error('生成失败');
                }
            });
        },
        onGenerateNewFormulaCancel() {
            this.generateNewFormulaVisible = false;
        },
        async onFormulaSearch(value) {
            const params = {
                size: 20,
                current: 1,
                factoryId: window.localStorage.getItem('factoryId'),
                formulaType: this.formulaType,
                status: 0,
                formulaKeyword: value
            };
            this.formulaFetching = true;
            const res = await this.$get("/nhf-app/formulaManage/myFormulaNhfPage", params);
            if (res.data && res.data?.records) {
                this.formulaList = res.data.records;
            }
            this.formulaFetching = false;
        },
        onFormulaChange(value) {
            this.form.formulaId = value;
        },
        onImportFormulaModelBtnClick() {
            this.importFormulaModelVisible = true;
        },
        importFormulaModel() {
            this.$http.post('/nhf-app/formulaproductext/importFormula', { formulaId: this.form.formulaId, productId: this.productId }).then(res => {
                if (res.success) {
                    this.$message.success('导入成功');
                    this.importFormulaModelVisible = false;
                } else {
                    this.$message.error('导入失败');
                }
            });
        },
        onImportFormulaModelCancel() {
            this.importFormulaModelVisible = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.footer-content {
    .ant-btn {
        margin-right: 12px;
    }
}
</style>
